// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import NotificationTwoToneSvg from "@fishx/icons-svg/es/asn/NotificationTwoTone";
import FishxIcon from '../components/FishxIcon';

var NotificationTwoTone = function NotificationTwoTone(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: NotificationTwoToneSvg
  }));
};

NotificationTwoTone.displayName = 'NotificationTwoTone';
export default React.forwardRef(NotificationTwoTone);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/NotificationTwoTone.js
// module id = 3173
// module chunks = 0